/**
 * Similar to https://github.com/chenqingspring/react-lottie/blob/master/src/index.js
 * Using functional React and the lottie lite-player
 */
import { AnimationItem, SVGRendererConfig } from "lottie-web";
import lottieLight from "lottie-web/build/player/lottie_light"; // 164kb - compared to 264kb for non-light.
import React, { useEffect, useRef } from "react";

export interface RequiredImplementingProps {
    onComplete?: () => void;
    onAnimationStart?: () => void;
}

interface LottieProps extends RequiredImplementingProps {
    animationData: any;
    loop: boolean;
    rendererSettings?: SVGRendererConfig;
    className?: string;
}

function Lottie({
    animationData,
    loop,
    rendererSettings,
    className,
    onComplete,
    onAnimationStart,
}: LottieProps): JSX.Element {
    let lottieElementRef = useRef<HTMLDivElement>(null);
    let lottiePlayerRef = useRef<null | AnimationItem>(null);
    useEffect(() => {
        if (lottieElementRef.current == null) {
            return;
        }

        lottiePlayerRef.current = lottieLight.loadAnimation({
            container: lottieElementRef.current,
            animationData,
            loop: loop,
            autoplay: true,
            rendererSettings,
        });

        if (onComplete) lottiePlayerRef.current.addEventListener("complete", onComplete);
        if (onAnimationStart) onAnimationStart();

        return (): void => {
            lottiePlayerRef.current?.removeEventListener("complete", onComplete);
            lottiePlayerRef.current?.destroy();
        };
    }, [animationData, loop, rendererSettings, onComplete, onAnimationStart]);

    return <div className={className} ref={lottieElementRef}></div>;
}

export default Lottie;
